import { FormControl, InputLabel, Select, SelectProps } from '@mui/material'
import Menu from '../../MenuV2'

export default function FilterPanelSelect({
    options,
    onChange,
    label,
    children,
    variant = 'outlined',
    sx,
    ...props
}: Omit<SelectProps, 'variant'> & {
    children?: React.ReactNode
    label: string
    variant?: SelectProps['variant']
    options:
        | {
              value: string
              label: React.ReactNode
          }[]
        | undefined
}) {
    return (
        <FormControl variant="outlined" fullWidth sx={sx}>
            <InputLabel id={`${label}-select-label`} shrink>
                {label}
            </InputLabel>
            <Select
                {...props}
                onChange={onChange}
                labelId={`${label}-select-label`}
                id={`${label}-select`}
                label={label}
                variant={variant}
                size="small"
                fullWidth
            >
                {children}
                {options?.map(({ value, label }) => (
                    <Menu.Item key={value} value={value}>
                        {label}
                    </Menu.Item>
                ))}
            </Select>
        </FormControl>
    )
}
